import elementoVisivel from '../dom';

const PAINEL = '[data-tour="licitacoes-filtros"]';
const CHIPS = '[data-tour="licitacoes-chips"]';
const LIMPAR = '[data-tour="licitacoes-limpar"]';
const FILTRAR = '[data-tour="licitacoes-filtrar"]';

export default {
  id: 'licitacoes-filtros',
  kind: 'tour',
  version: 2,
  label: 'Filtrar licitações',
  contexts: ['licitacoes.lista'],
  scopes: ['filtros'],
  priority: 10,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.filtrosVisiveis);
  },
  canStart(ctx = {}) {
    if (!ctx.filtrosVisiveis) return false;
    return Boolean(elementoVisivel(PAINEL));
  },
  steps() {
    const steps = [
      {
        element: PAINEL,
        popover: {
          title: 'Filtros',
          description:
            'Refine a listagem por situação, período, objeto e outros critérios disponíveis.',
          side: 'bottom',
          align: 'start',
        },
      },
    ];

    if (elementoVisivel(CHIPS)) {
      steps.push({
        element: CHIPS,
        popover: {
          title: 'Atalhos de situação',
          description: "Estes atalhos pré-selecionam situações comuns, como 'Em andamento'.",
          side: 'top',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(LIMPAR)) {
      steps.push({
        element: LIMPAR,
        popover: {
          title: 'Limpar',
          description: 'Remove os filtros aplicados e recarrega a listagem padrão.',
          side: 'top',
          align: 'end',
        },
      });
    }

    if (elementoVisivel(FILTRAR)) {
      steps.push({
        element: FILTRAR,
        popover: {
          title: 'Filtrar',
          description: 'Aplica os filtros selecionados e atualiza os resultados da listagem.',
          side: 'top',
          align: 'end',
        },
      });
    }

    return steps;
  },
};
